import React, {Component} from 'react'
import { connect } from "react-redux"

import trans from "trans"

import { updateInputValue as change } from "app/reducers/form"
import { Project } from "app/types/model-types"
import {RandomProduct} from "shape-edit/types";
import {createToast, setRandomProduct} from "actions";
import { selectFormValues } from 'app/reducers/form'
import { getFormName } from 'shape-edit/forms/helpers'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'
import { Range } from '@bdfx/mergado-ui-kit'

export interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    randomProduct: RandomProduct
    handleUpdateEffect: Function
    change: typeof change
    setRandomProduct: typeof setRandomProduct
    project: Project
}

export interface State {
    isRendering: boolean
    isLoaded: boolean
    newX: number
    newY: number
    newFuzz: number
    validateNow: boolean
}

const defaultFuzz = 600

class EffectsForm extends Component<Props,State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoaded: false,
            isRendering: false,
            newX: null,
            newY: null,
            newFuzz: defaultFuzz,
            validateNow: false,
        }
    }

    render() {
        const {form, project, isAlt} = this.props

        const { isRendering } = this.state
        const userId = project.user && project.user.id ? project.user.id : null

        const formName = getFormName(isAlt)

        return (
            <>
                <Range
                    label={trans("brightness")}
                    name={`${formName}.effects.brightness`}
                    min={-100}
                    max={100}
                    step={1}
                    value={form?.effects?.brightness}
                    defaultValue={0}
                    placeholder={'0'}
                    onChange={(val) => this.props.handleUpdateEffect(val, 'brightness')}
                    onClear={() => this.props.handleUpdateEffect(null, 'brightness')}
                />

                <Range
                    label={trans("contrast")}
                    name={`${formName}.effects.contrast`}
                    min={-100}
                    max={100}
                    step={1}
                    value={form?.effects?.contrast}
                    defaultValue={0}
                    placeholder={'0'}
                    onChange={(val) => this.props.handleUpdateEffect(val, 'contrast')}
                    onClear={() => this.props.handleUpdateEffect(null, 'contrast')}
                />

                <Range
                    label="Gamma"
                    name={`${formName}.effects.gamma`}
                    min={0.8}
                    max={2.3}
                    step={.1}
                    value={form?.effects?.gamma}
                    placeholder={'1'}
                    defaultValue={1}
                    onChange={(val) => this.props.handleUpdateEffect(val, 'gamma')}
                    onClear={() => this.props.handleUpdateEffect(null, 'gamma')}
                />

                {/*HIDDEN TEMPORARILY*/}
                {/*{!form.is_collage &&
                <>
                    <DistortionForm form={form} handleUpdateEffect={this.props.handleUpdateEffect}/>
                    <GridCell col={'1/-1'}><StyledSeparator/></GridCell>
                </>
                }*/}
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        randomProduct: state.randomProduct,
        project: state.project.data,
    }
}

export default connect(mapStateToProps, {
    change,
    createToast,
    setRandomProduct,
})(EffectsForm)